module.exports = __webpack_public_path__ + "static/img/teleservice22.1eb0fd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/teleservice22.jpg
// module id = cqMe
// module chunks = 0